import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Aos from "aos";
import { Suspense, lazy, useContext } from "react";
import Loader from "./components/Notifications/Loader";
import Toast from "./components/Notifications/Toast";
import SafeRoute from "./components/SafeRoute";
import { SnackbarProvider } from "notistack";

import ReceptionRoutes from "./routes/ReceptionRoutes";
import UserContext from "./context/UserContext";
import AdminRoutes from "./routes/AdminRoutes";
import Dashboard from "./screens/Dashboard";
import DoctorRoutes from "./routes/DoctorRoutes";
import { ForgotPassword } from "./components/Auth/ForgotPassword";
import { ResetPassword } from "./components/Auth/ResetPassword";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import SuperAdminRoutes from "./routes/SuperAdminRoutes";
import PatientRoutes from "./routes/PatientRoutes";

import RegistrationPage from "./components/Registration/RegistrationPage";
import OtpPage from "./screens/OtpPage";

const NotFound = lazy(() => import("./screens/NotFound"));
const Login = lazy(() => import("./screens/Login"));

// Custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#6CCCF1", // Primary color
    },
    secondary: {
      main: "#808080", // Default secondary color
    },
    pink: {
      main: "#ff8da1", // Custom pink color
    },
  },
});

function App() {
  Aos.init();
  const { user } = useContext(UserContext);

  const role = user?.role === "reception" ? "receptionist" : user?.role;
  return (
    <ThemeProvider theme={theme}>
      <Toast />
      <BrowserRouter>
        <SnackbarProvider>
          <SafeRoute>
            {/* <LanguageSelector /> */}

            <Suspense
              fallback={
                user?.role === "patient" ? (
                  <div className="h-screen flex items-center justify-center bg-gray-100">
                    <p className="text-2xl font-bold text-gray-700">
                      Loading...
                    </p>
                  </div>
                ) : (
                  <Loader />
                )
              }>
              <Routes>
                {user ? (
                  <>
                    {/* <Route path="/" element={<Dashboard />} /> */}
                    {/* Role-based routes */}
                    <Route
                      path="/superadmin/*"
                      element={
                        user?.role === "superadmin" && <SuperAdminRoutes />
                      }
                    />
                    <Route
                      path="/admin/*"
                      element={user?.role === "admin" && <AdminRoutes />}
                    />
                    <Route
                      path="/doctor/*"
                      element={user?.role === "doctor" && <DoctorRoutes />}
                    />
                    <Route
                      path="/receptionist/*"
                      element={
                        user?.role === "reception" && <ReceptionRoutes />
                      }
                    />
                    <Route
                      path="/patient/*"
                      element={user?.role === "patient" && <PatientRoutes />}
                    />
                    <Route
                      path="*"
                      element={<Navigate to={`/${role}`} replace />}
                    />
                  </>
                ) : (
                  <>
                    <Route path="/" element={<Login />} />
                    <Route path="/otp" element={<OtpPage />} />
                    {/* <Route path="/sign-up" element={<RegistrationPage />} /> */}
                    <Route
                      path="/forgot-password"
                      element={<ForgotPassword />}
                    />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </>
                )}
                {/* <Route
                  path="*"
                  element={<Navigate to={user ? `/${role}` : "/"} replace />}
                /> */}
              </Routes>
            </Suspense>
          </SafeRoute>
        </SnackbarProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
